import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { trackPageView } from '@/lib/trackPageView';

export default function PageViewTracker() {
  const { pathname } = useLocation();
  const { locale } = useLanguage();

  useEffect(() => {
    trackPageView({ path: pathname, locale });
  }, [pathname, locale]);

  return null;
}
